import React from 'react';


// auth pages
import PinUpdate from '../Pages/Auth/PinUpdate/PinUpdate';

export const routesListAuth = [
    {
        id: 0,
        name: "Credential",
        path: "/member_update",
        pageTitle: "Credential",
        component: <PinUpdate />,
        public: true,
    },
];